import { useDateFormatter, useTranslator } from '@bluebeam/react-i18n';
import DateDropdown from 'components/inputs/dropdowns/DateDropdown';
import Label from 'components/inputs/Label';
import Immutable from 'immutable';
import React, { FC } from 'react';
import { Punch } from 'records/Punch';

interface Props {
  duedate: number;
  actualPunches: Immutable.Set<Punch>;
  onChange: (date: Date) => void;
}

const DueDate: FC<Props> = ({ duedate, actualPunches, onChange }) => {
  const { translate } = useTranslator(['updateMultiplePunchOverlay']);
  const dateFormatter = useDateFormatter({
    dateStyle: 'short',
  });
  const getDueDateText = (): string => {
    const allEmpty = actualPunches.every((p) => p.duedate === 0);
    if (allEmpty) {
      return translate('updateMultiplePunchOverlay:dueDate.noDueDate');
    }

    const firstPunch = actualPunches.first<Punch>();
    const allSame = actualPunches.every(
      (p) => p.duedate === firstPunch.duedate
    );

    if (allSame) {
      const date = new Date(firstPunch.duedate * 1000);
      return dateFormatter.format(date);
    }

    return 'Multiple';
  };

  return (
    <div className="grow-1 w100 new-punch-duedate">
      <style>
        {`
            .new-punch-duedate .react-datepicker-wrapper {
              width: 100%;
            }

            .new-punch-duedate .react-datepicker-popper {
              margin-left: -20px
            }
          `}
      </style>
      <Label label={translate('updateMultiplePunchOverlay:dueDate.label')} />
      <div>
        <DateDropdown
          id="update-multi-punch-overlay-duedate"
          date={duedate}
          onChange={onChange}
          placeholderText={getDueDateText()}
        />
      </div>
    </div>
  );
};

export default DueDate;
